import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, FormControlLabel, Switch} from '@mui/material';
import { TextField } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { get, set } from '@totalsoft/change-tracking-react';

export const HierarchyGeneralDataComponent = ({
    hierarchyHeader,
    validation,
    canWrite
  }) => {

  const onCheckBoxChange = onPropertyChange => event => onPropertyChange(event.target.checked);
  const [t] = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          value={(hierarchyHeader.hierarchyCode |> get) || ''}
          onChange={hierarchyHeader.hierarchyCode |> set}
          label={t('PartnerHierarchy.HierarchyCode')}
          error={!isValid(validation.hierarchyCode)}
          helperText={getErrors(validation.hierarchyCode)}
          disabled={!canWrite || (hierarchyHeader.isActive |> get) === true}
          required
        />
      </Grid>     
      
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          value={(hierarchyHeader.hierarchyName |> get) || ''}
          onChange={hierarchyHeader.hierarchyName |> set}
          label={t('PartnerHierarchy.HierarchyName')}
          error={!isValid(validation.hierarchyName)}
          helperText={getErrors(validation.hierarchyName)}
          disabled={!canWrite || (hierarchyHeader.isActive |> get) === true}
          required
        />
      </Grid>   
      <Grid item xs={12} sm={1}>
        <FormControlLabel
          control={<Switch checked={(hierarchyHeader.isActive |> get) || false} />}
          onChange={hierarchyHeader.isActive |> set |> onCheckBoxChange}
          label={t('PartnerHierarchy.IsActive')}
          disabled={!canWrite}
        />
      </Grid>
    </Grid>
  );
};

HierarchyGeneralDataComponent.propTypes = {
    hierarchyHeader: PropTypes.object.isRequired,
    validation: PropTypes.object.isRequired,
    canWrite: PropTypes.bool
  };
  
  export default HierarchyGeneralDataComponent;
  